import "./styles/property-table.scss";
host.plugins.register({
    // #region Vars
    name: "288a.web.cms",
    // #endregion
    // #region Register
    register() {
        host.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
    },
    // #endregion
});
